import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Menu from '../../Layout/Menu/Menu';
import { Navigation, NavigationMobile } from '../Navigation/Menu';
import Table from "../../Layout/Table/Table";
import CampaignsRequests from "./CampaignsRequests";
import ModalCampaignType from "./form/ModalCampaignType";
import { Button } from "react-bootstrap";
import './Campaigns.css'
import ModalCampaignNotificationSegment from "./form/ModalCampaignNotificationSegment";
import ModalCampaignAction from "./form/ModalCampaignAction";
import ModalCampaignInfo from "./form/ModalCampaignInfo";
import { Puff } from 'react-loading-icons'
import ModalNoPlanActive from "./ModalNoPlanActive";
import ModalInstructions from "./ModalInstructions";
import NavBar from "../../../components/NavBar";
import CampaignCard from "./CampaignCard";



const CampaignsList = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [planActive, setPlanActive] = useState(true);
    const [data, setData] = useState({
        list: []
    })
    const [modalNoPlanActive, setModalNoPlanActive] = useState({
        isVisible: false,
    })
    const [modalInstructions, setModalInstructions] = useState({
        isVisible: false,
    })
    const [formCampaign, setFormCampaign] = useState({
        modalType: {
            isVisible: false
        },
        modalSegment: {
            isVisible: false
        },
        modelAction: {
            isVisible: false
        },
        campaign: {
            id: 0,
            type: "",
            name: "",
            release_date: "",
            genero: ["Feminino", "Masculino", "Outro"],
            audience: {
                age_enabled: 1,
                age_start: 16,
                age_end: 60,
                gender_enabled: 0,
                gender: [],
                location_enabled: 1,
                location_lng: "",
                location_lat: "",
                location_range_km: "",
            },
            message: {
                text: "",
                target_type: "event",
                target_id: 0

            },
            limits: {
                limit: 0,
                usage: 0,
                total: 0,
            },
            errors: []
        },
        modalInfoCampaign: {
            isVisible: false,
            campaign: {}
        }

    })

    // useEffect(() => {
    //     getCampainsNotificationsLimits()
    // }, [formCampaign.campaign.audience, formCampaign.campaign.message.target_id])


    const handlerSubmitFormCampaign = async () => {
        let info = await CampaignsRequests.postFormCampaigns(formCampaign.campaign);
        if (info && info.status) {
            setFormCampaign({
                ...formCampaign,
                modalSegment: {
                    ...formCampaign.modalSegment,
                    isVisible: false,
                }
            });
        }
    }

    // const getCampainsNotificationsLimits = async () => {
    //     let info = await CampaignsRequests.getNotiicationsLimits(formCampaign.campaign);
    //     if (info && info.status) {
    //         setFormCampaign({
    //             ...formCampaign,
    //             campaign: {
    //                 ...formCampaign.campaign,
    //                 limits: {
    //                     ...formCampaign.campaign.limits,
    //                     ...info.data
    //                 }
    //             }
    //         });
    //     }
    const getListCampaigns = async () => {
        setIsLoading(true);
        let info = await CampaignsRequests.getListCampaigns({});
        if (info && info.status) {
            setData({
                ...data,
                list: info.data.campaignsList
            })

            setPlanActive(info.data.planActive)
        }
        setIsLoading(false);
    }
    useEffect(() => {
        document.title = 'Campanhas | Nightspot Dashboard';
        getListCampaigns()
    }, [])

    const handlerGetInfoCampaign = async (id) => {

        let info = await CampaignsRequests.getCampaignInfo({ id: id });
        if (info && info.status) {
            setFormCampaign({
                ...formCampaign,
                modalInfoCampaign: {
                    ...formCampaign.modalInfoCampaign,
                    isVisible: true,
                    campaign: info.data.campaign
                }
            })
        }
    }

    const handleAddClick = () => {
        setFormCampaign({
            ...formCampaign,
            modalType: {
                ...formCampaign.modalType,
                isVisible: true
            },
        })

    };

    const InsideLoading = () => (
        <div className="d-flex flex-column align-items-center justify-content-center py-5">
            <Puff stroke="#6366f1" height="4em" width="4em" />
            <div className="text-muted mt-3 fw-bold">A carregar campanhas...</div>
        </div>
    );

    const MagicAddCard = () => (
        <div className="col-12 col-md-6 col-lg-4 p-2 mb-3">
            <div
                className="campaign-card magic-add-card-campaign d-flex flex-column align-items-center justify-content-center text-center p-4 h-100"
                onClick={handleAddClick}
            >
                <div className="mb-3">
                    <i className="fa-solid fa-plus fs-2 text-nightspot"></i>
                </div>
                <h3 className="title mb-1">Nova Campanha</h3>
                <p className="text-muted small">Cria notificações segmentadas para o teu público.</p>
            </div>
        </div>
    );

    const NoResults = () => (
        <div className="col-12 text-center py-5 mt-4">
            <div className="mb-4">
                <i className="fa-solid fa-bullhorn fs-1 text-muted opacity-25"></i>
            </div>
            <h3 className="text-white opacity-75">Ainda não criaste nenhuma campanha</h3>
            <p className="text-muted mb-4">Usa as campanhas para chegar a mais clientes e aumentar as tuas reservas.</p>
            <button onClick={handleAddClick} className="btn-action btn-campaign-primary px-5 rounded-pill w-auto mx-auto py-2">
                Criar a primeira campanha
            </button>
        </div>
    );

    return (
        <NavBar>
            <div className="py-4 dashboard-content">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/my/dashboard">
                                <i className="fa-solid fa-house-chimney me-2"></i>Dashboard
                            </Link>
                        </li>
                        <li className="breadcrumb-item active">Campanhas</li>
                    </ol>
                </nav>

                <div className="row mb-5 align-items-center">
                    <div className="col-12 col-md-8">
                        <h1 className="campaigns-section-title">Campanhas</h1>
                        <p className="campaigns-section-subtitle mb-0">Comunica diretamente com o teu público através de notificações segmentadas.</p>
                    </div>
                    <div className="col-12 col-md-4 d-flex justify-content-md-end mt-3 mt-md-0">
                        <button
                            onClick={() => setModalInstructions({ ...modalInstructions, isVisible: true })}
                            className="btn-action btn-campaign-secondary px-4 rounded-pill w-auto py-2"
                        >
                            <i className="fa-solid fa-book-open me-2"></i>
                            Instruções
                        </button>
                    </div>
                </div>

                {isLoading ? <InsideLoading /> : (
                    <div className="row g-3">
                        <MagicAddCard />
                        {data.list.length > 0 ? (
                            data.list.map((item, key) => (
                                <CampaignCard
                                    key={key}
                                    item={item}
                                    onDetails={handlerGetInfoCampaign}
                                />
                            ))
                        ) : null}
                        {data.list.length === 0 && <NoResults />}
                    </div>
                )}


                <ModalCampaignType
                    show={formCampaign.modalType.isVisible}
                    handleModalhide={() =>
                        setFormCampaign({
                            ...formCampaign,
                            modalType: {
                                ...formCampaign.modalType,
                                isVisible: false
                            },
                            campaign: {
                                ...formCampaign.campaign,
                                errors: []
                            }
                        })
                    }
                    handlerCampaignType={(type) =>

                        setFormCampaign({
                            ...formCampaign,
                            modalType: {
                                ...formCampaign.modalType,
                                isVisible: false
                            },
                            modalSegment: {
                                ...formCampaign.modalSegment,
                                isVisible: false
                            },
                            modelAction: {
                                ...formCampaign.modelAction,
                                isVisible: true
                            },

                            campaign: {
                                ...formCampaign.campaign,
                                type: type,
                                name: '',
                                ageRange: [16, 60],
                                genero: ["Feminino", "Masculino", "Outro"],
                                numNotificacoes: null,
                                message: {
                                    text: "",
                                    target_type: "event",
                                    target_id: 0

                                },
                                errors: []
                            },

                        })
                    }
                />
                <ModalCampaignNotificationSegment
                    show={formCampaign.modalSegment.isVisible}
                    form={formCampaign.campaign}
                    handleModalhide={() =>
                        setFormCampaign({
                            ...formCampaign,
                            modalType: {
                                ...formCampaign.modalType,
                                isVisible: false
                            },
                            modalSegment: {
                                ...formCampaign.modalType,
                                isVisible: false
                            },
                            modelAction: {
                                ...formCampaign.modelAction,
                                isVisible: true
                            }
                        })
                    }
                    handleChangeForm={(e) => {
                        setFormCampaign({
                            ...formCampaign,
                            campaign: {
                                ...formCampaign.campaign,
                                [e.target.name]: e.target.value
                            }
                        })
                    }}

                    handleSetErrors={(e) => {
                        let array = []
                        array[e.target.name] = [e.target.value]
                        console.log(array)
                        setFormCampaign({
                            ...formCampaign,
                            errors: [...formCampaign.errors, array]
                        })
                    }}
                    handlerSegment={() =>
                        handlerSubmitFormCampaign()
                        // setFormCampaign({
                        //     ...formCampaign,
                        //     modalSegment: {
                        //         ...formCampaign.modalSegment,
                        //         isVisible: false
                        //     },
                        //     modelAction: {
                        //         ...formCampaign.modelAction,
                        //         isVisible: true
                        //     }
                        // })
                    }


                />
                <ModalCampaignAction
                    show={formCampaign.modelAction.isVisible}
                    form={formCampaign.campaign}
                    handleModalhide={() =>
                        setFormCampaign({
                            ...formCampaign,
                            modalSegment: {
                                ...formCampaign.modalSegment,
                                isVisible: false
                            },
                            modalType: {
                                ...formCampaign.modalType,
                                isVisible: true
                            },
                            modelAction: {
                                ...formCampaign.modelAction,
                                isVisible: false
                            }
                        })
                    }
                    handleChangeForm={(e) =>
                        setFormCampaign({
                            ...formCampaign,
                            campaign: {
                                ...formCampaign.campaign,
                                message: {
                                    ...formCampaign.campaign.message,
                                    [e.target.name]: e.target.value
                                }
                            }
                        })
                    }
                    handlerSubmitCampain={(e) => {
                        setFormCampaign({
                            ...formCampaign,
                            modalSegment: {
                                ...formCampaign.modalSegment,
                                isVisible: true
                            },
                            modelAction: {
                                ...formCampaign.modelAction,
                                isVisible: false
                            }
                        })

                    }}
                    handleSetErrors={(e) => {
                        let array = []
                        array[e.target.name] = [e.target.value]
                        setFormCampaign({
                            ...formCampaign,
                            campaign: {
                                ...formCampaign.campaign,
                                errors: array
                            }

                        })
                    }}

                />

                <ModalCampaignInfo
                    show={formCampaign.modalInfoCampaign.isVisible}
                    info={formCampaign.modalInfoCampaign.campaign}
                    handleModalhide={() =>
                        setFormCampaign({
                            ...formCampaign,
                            modalInfoCampaign: {
                                ...formCampaign.modalInfoCampaign,
                                isVisible: false
                            },
                        })
                    }


                />
                <ModalNoPlanActive
                    show={modalNoPlanActive.isVisible}
                    handleModalhide={() =>
                        setModalNoPlanActive({
                            ...modalNoPlanActive,
                            isVisible: false
                        })
                    }
                />
                <ModalInstructions
                    show={modalInstructions.isVisible}
                    handleModalhide={() =>
                        setModalInstructions({
                            ...modalInstructions,
                            isVisible: false
                        })
                    }
                />

            </div>

        </NavBar >
    )
}


export default CampaignsList;